export const DIAGNOSTICO_STATUS_TYPE = {
  QUEIMA_CAIXA: "QUEIMA_CAIXA",
  RISCO_ASSUMIDO: "RISCO_ASSUMIDO",
  CORRETO: "CORRETO",
  A_OTIMIZAR: "A_OTIMIZAR",
};

export const DIAGNOSTICO_GOOD_FOR_SALE_TYPE = {
  DEBITO_ESTORNAR: "DEBITO_ESTORNAR",
  NAO_RECONHECIDOS: "NAO_RECONHECIDOS",
  CREDITO_A_ESTORNAR: "CREDITO_A_ESTORNAR",
};

export const DIAGNOSTICO_SPED_CREDITS_TABS = {
  CREDITOS: "CREDITOS",
  DOWNLOADS: "DOWNLOADS",
  COMPLEMENTO_CREDITOS: "COMPLEMENTO_CREDITOS",
  CONFIGS: "CONFIGS",
  CLASSIFICACAO: "CLASSIFICACAO",
};
